(() => {
  const HEADER_SELECTOR = ".section-header.shopify-section-group-header-group";
  const HIDE_CLASS = "eots-hide";

  // Schwellen (Delay-Gefühl)
  const SHOW_THRESHOLD_PX = 120;
  const HIDE_THRESHOLD_PX = 120;

  // Touch / Desktop erkennen
  const isTouch =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  // Erst ab X px überhaupt reagieren
  const MIN_Y_BEFORE_HIDE_DESKTOP = 50;
  const MIN_Y_BEFORE_HIDE_MOBILE  = 100;
  const MIN_Y_BEFORE_HIDE = isTouch
    ? MIN_Y_BEFORE_HIDE_MOBILE
    : MIN_Y_BEFORE_HIDE_DESKTOP;

  // Schutz gegen "Plopp" beim Laden
  const FREEZE_AFTER_LOAD_MS = 500;

  let header;
  let lastY = 0;
  let accDown = 0;
  let accUp = 0;
  let freezeUntil = 0;

  function getY() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function onScroll() {
    if (!header) return;

    const now = Date.now();
    if (now < freezeUntil) return;

    const y = getY();
    const dy = y - lastY;

    // Vor Erreichen der Mindesthöhe: immer sichtbar
    if (y <= MIN_Y_BEFORE_HIDE) {
      header.classList.remove(HIDE_CLASS);
      accDown = 0;
      accUp = 0;
      lastY = y;
      return;
    }

    // Mini-Jitter ignorieren
    if (Math.abs(dy) < 2) {
      lastY = y;
      return;
    }

    if (dy > 0) {
      // Scroll DOWN
      accDown += dy;
      accUp = 0;

      if (accDown >= HIDE_THRESHOLD_PX) {
        header.classList.add(HIDE_CLASS);
        accDown = 0;
      }
    } else {
      // Scroll UP
      accUp += Math.abs(dy);
      accDown = 0;

      if (accUp >= SHOW_THRESHOLD_PX) {
        header.classList.remove(HIDE_CLASS);
        accUp = 0;
      }
    }

    lastY = y;
  }

  function init() {
    header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    lastY = getY();
    freezeUntil = Date.now() + FREEZE_AFTER_LOAD_MS;

    header.classList.remove(HIDE_CLASS);

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => { lastY = getY(); }, { passive: true });

    setTimeout(() => { freezeUntil = 0; }, FREEZE_AFTER_LOAD_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

